<template>
  <!-- Плашка показывается только если visible === true -->
  <div v-if="visible" class="email-alert">
    <div class="email-alert__content">
      <!-- Иконка письма (простой SVG без внешних зависимостей) -->
      <div class="email-alert__icon">
        <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
          <polyline points="22,6 12,13 2,6"></polyline>
        </svg>
      </div>
      
      <!-- Текстовый блок -->
      <div class="email-alert__text">
        <h4 class="email-alert__title">Подтвердите ваш Email</h4>
        <!-- <p class="email-alert__description">
          Мы отправили письмо со ссылкой для подтверждения на адрес 
          <strong class="email-alert__user-email">{{ email }}</strong>. 
          Пожалуйста, проверьте почту (включая папку «Спам»).
        </p> -->
        <p class="email-alert__description">
          На указанный email адрес отправлено письмо со ссылкой для подтверждения.
          Пожалуйста, проверьте почту (включая папку «Спам»).
        </p>
      </div>
    </div>

    <!-- Кнопка закрытия плашки -->
    <button v-if="showClose" class="email-alert__close-btn" @click="closeAlert" aria-label="Закрыть">
      &times;
    </button>
  </div>
</template>

<script>
export default {
  name: 'EmailConfirmationAlert',
  props: {
    // Передаем email динамически из родительского компонента после регистрации
    // email: {
    //   type: String,
    //   required: true,
    //   default: 'your-email@example.com'
    // },
    showClose: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: true
    };
  },
  methods: {
    closeAlert() {
      this.visible = false;
      // Генерируем событие, чтобы родительский компонент знал, что плашка закрыта
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
.email-alert {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  background-color: #e0f2fe; /* Нежно-голубой фон */
  border: 1px solid #bae6fd; /* Синяя граница */
  border-radius: 8px;
  padding: 16px;
  margin: 16px 0;
  font-family: system-ui, -apple-system, sans-serif;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.email-alert__content {
  display: flex;
  gap: 12px;
}

.email-alert__icon {
  color: #0284c7; /* Цвет иконки */
  flex-shrink: 0;
  margin-top: 2px;
}

.email-alert__text {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.email-alert__title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #0369a1; /* Темно-синий заголовок */
}

.email-alert__description {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  color: #334155; /* Комфортный для чтения цвет текста */
}

.email-alert__user-email {
  color: #0f172a;
}

.email-alert__close-btn {
  background: none;
  border: none;
  font-size: 22px;
  line-height: 1;
  color: #94a3b8;
  cursor: pointer;
  padding: 0 4px;
  transition: color 0.2s ease;
}

.email-alert__close-btn:hover {
  color: #475569; /* Смена цвета при наведении */
}
</style>